import React from 'react';
import CatalogPage from './CatalogPage';

const MangaPageSimple = () => <CatalogPage forcedCategory="manga" title="Manga" />;

export default MangaPageSimple;
